import { trackLink } from "../../../../../../services/analytics";
import {
  ITEMS_TYPE_CUSTOMER_ITEMS,
  ITEMS_TYPE_SHARED_BOARD
} from "../../constants";
import { moveItemToBag } from "./moveItemToBag";
import { addItemToBag } from "./addItemToBag";

const reducerMap = {
  [ITEMS_TYPE_CUSTOMER_ITEMS]: moveItemToBag,
  [ITEMS_TYPE_SHARED_BOARD]: addItemToBag
};

export const itemToBag = (state, action) => {
  const { itemsType } = state;
  const newState = reducerMap[itemsType](state, action);
  trackLink({ state: newState });

  return newState;
};
